export default "__VITE_ASSET__BkV2iFLt__"